/**
 * Returns a component that renders the given component with the given props
 * before its own props.
 * @param props - The partial props to be injected.
 * @param Comp - The component to be enhanced.
 * @returns - The enhanced component.
 */
export const withProps =
    <TProps extends object, TPartialProps extends keyof TProps>(
        props: { [K in TPartialProps]: TProps[K] },
        Comp: React.ComponentType<TProps>
    ) =>
    (field: Omit<TProps, TPartialProps>) =>
        (
            <Comp
                {...({
                    ...field,
                    ...props,
                } as TProps)}
            />
        )
